module.exports = __webpack_public_path__ + "static/media/event3_canada.c74a2182.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/event3_canada.jpg
 ** module id = 112
 ** module chunks = 0
 **/